import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { SiteConfigService } from './site-config.service';
import { TenantSiteConfig } from '../../models/wholesaler-api-models';

interface SiteConfig {
  siteConfig: TenantSiteConfig | null;
  loading: boolean;
}

const initialState: SiteConfig = {
  siteConfig: null,
  loading: false,
};

export const SiteConfigStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(({ ...store }) => ({
    async initSiteConfig() {
      const tenantConfig = inject(SiteConfigService);

      const config = await tenantConfig.getSiteConfig();
      patchState(store, {
        siteConfig: config,
      });
    },
    resetStore() {
      patchState(store, initialState);
    },
  })),
);
